import { get } from "https";
import { deleteRequest, getHtmlRequest, getRequest, postRequest, postHtmlRequest } from "../utils/fetch";
import { Guid } from "../utils/guid";

const baseUrl: string = "/apicore/inlineedit/";

export interface IAuthResponse {
	token: string;
	refreshToken: string;
	email: string;
	fullName: string;
	avatar: string;
	roles: string[];
	claims: string[];
	domains: string[];
	assemblyVersion: string;
}

export interface IUpdateContentItemFieldRequest {
	pageId: Guid;
	contentItemId: Guid;
	contentKeyName: string;
	fieldName: string;
	fieldValue: string;
	flushContent: boolean;
}

export interface IUpdateContentItemFieldResponse {
	isSuccess: boolean;
	errorMessage: string;
	successMessage: string;
}

export function login(googleIdToken: string): Promise<any> {
	return postRequest<string, any>(`${baseUrl}login`, googleIdToken, {
		headers: { "Content-type": "application/json; charset=utf-8" },
	});
}

export function logout(): Promise<string> {
	return deleteRequest(`${baseUrl}logout`, {});
}

export function saveContentItemFieldAsync(
	requestData: IUpdateContentItemFieldRequest,
): Promise<IUpdateContentItemFieldResponse> {
	return postRequest<IUpdateContentItemFieldRequest, IUpdateContentItemFieldResponse>(
		`${baseUrl}SaveContentItemField`,
		requestData,
		{
			headers: { "Content-type": "application/json; charset=utf-8" },
		},
	);
}
